// Canadian provinces and territories. Listings store the two-letter code.

export const PROVINCES = [
  { code: 'QC', en: 'Quebec', fr: 'Québec' },
  { code: 'ON', en: 'Ontario', fr: 'Ontario' },
  { code: 'BC', en: 'British Columbia', fr: 'Colombie-Britannique' },
  { code: 'AB', en: 'Alberta', fr: 'Alberta' },
  { code: 'MB', en: 'Manitoba', fr: 'Manitoba' },
  { code: 'SK', en: 'Saskatchewan', fr: 'Saskatchewan' },
  { code: 'NS', en: 'Nova Scotia', fr: 'Nouvelle-Écosse' },
  { code: 'NB', en: 'New Brunswick', fr: 'Nouveau-Brunswick' },
  { code: 'NL', en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador' },
  { code: 'PE', en: 'Prince Edward Island', fr: 'Île-du-Prince-Édouard' },
  { code: 'NT', en: 'Northwest Territories', fr: 'Territoires du Nord-Ouest' },
  { code: 'YT', en: 'Yukon', fr: 'Yukon' },
  { code: 'NU', en: 'Nunavut', fr: 'Nunavut' },
] as const;

/** Lower case, no accents, hyphens and repeated spaces as one space. */
export function foldPlace(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/[-\u2010-\u2015]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// Both sides are folded: "Colombie-Britannique" typed with its hyphen used to
// miss, since only the typed text had its hyphens turned into spaces, and
// "Quebec" matched only because the English name happens to have no accent.
export function findProvince(value: string | null | undefined) {
  if (!value) return undefined;
  let decoded = value;
  try {
    decoded = decodeURIComponent(value);
  } catch {
    // Not URI-encoded after all.
  }
  const key = foldPlace(decoded);
  if (!key) return undefined;
  return PROVINCES.find((p) => p.code.toLowerCase() === key || foldPlace(p.en) === key || foldPlace(p.fr) === key);
}

export function provinceName(value: string, lang: string): string {
  const p = findProvince(value);
  if (!p) {
    // An address can carry anything (?province=%): what cannot be decoded is shown as it came.
    try { return decodeURIComponent(value).toUpperCase(); } catch { return value.toUpperCase(); }
  }
  return lang === 'fr' ? p.fr : p.en;
}
